<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />
    <h4>Estado Civil</h4>
    <hr />

    <DataTable
      :data="estadocivils"
      :columns="columnas"
      idField="idEstadoCivil"
      mensajeVacio="No hay estados civiles registrados."
      :mostrarBotonNuevo="true"
      :mostrarEditar="true"
      :mostrarVer="true"
      :mostrarEliminar="true"
      @refresh="getData"
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idEstadoCivil)"
      @view="row => abrirEditar(row.idEstadoCivil)"
      @delete="row => deleteEstadoCivil(row.idEstadoCivil)"
    >
      <!-- Búsqueda por nombre -->
      <template #acciones-extra>
        <div class="col-auto d-flex align-items-center gap-1">
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="nombreBusqueda"
            placeholder="Buscar nombre..."
            style="width:220px; text-transform:uppercase"
            @keyup.enter="getDataNombre"
          />
          <button
            class="btn btn-outline-primary btn-sm"
            @click="getDataNombre"
            title="Buscar"
          >
            <span class="material-icons" style="font-size:16px">search</span>
          </button>
        </div>
      </template>
    </DataTable>

    <!-- ── Modal ──────────────────────────────────────────────────── -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <!-- ID solo en edición -->
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">ID</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="datoEstadoCivil.idEstadoCivil"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <!-- Nombre -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Nombre</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="datoEstadoCivil.nombre"
                      style="text-transform:uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click.prevent="guardarEstadoCivil"
              v-if="btnCrear"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">save</span>
              Guardar
            </button>
            <button
              type="button"
              class="btn btn-warning"
              @click.prevent="actualizarEstadoCivil"
              v-if="btnEditar"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">update</span>
              Actualizar
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout          from "@/components/Layout.vue";
import Footer          from "@/components/Footer.vue";
import DataTable       from "@/components/DataTable.vue";
import api             from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import Swal            from "sweetalert2";
import * as $          from "jquery";
window["$"]      = $;
window["jQuery"] = $;

export default {
  name: "EstadoCivilList",
  components: { Layout, Footer, DataTable },

  data() {
    return {
      estadocivils:    [],
      datoEstadoCivil: {},
      nombreBusqueda:  "",
      titulo:          "",
      btnCrear:        false,
      btnEditar:       false,
      modalWindow:     true,
    };
  },

  computed: {
    columnas() {
      return [
        { label: "Nombre", field: "nombre" },
      ];
    },
  },

  mounted() {
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.getData();
  },

  methods: {
    // ── Carga de datos ────────────────────────────────────────
    getData() {
      this.nombreBusqueda = "";
      api.get("/vwestadocivils")
        .then(r => { this.estadocivils = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al cargar estados civiles:", e));
    },

    getDataNombre() {
      const nombre = this.nombreBusqueda.trim();
      if (!nombre) { this.getData(); return; }
      api.get("/vwestadocivils/nombre/" + nombre)
        .then(r => { this.estadocivils = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al buscar estado civil:", e));
    },

    // ── Validación ────────────────────────────────────────────
    validarForm() {
      return validarForm(
        this.datoEstadoCivil,
        ["nombre"],
        ["Nombre"]
      );
    },

    // ── CRUD ──────────────────────────────────────────────────
    async guardarEstadoCivil() {
      if (this.validarForm() !== 1) return;
      try {
        await api.post("/estadocivils", this.datoEstadoCivil);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Estado civil creado exitosamente." });
        this.getData();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
      }
    },

    async actualizarEstadoCivil() {
      if (this.validarForm() !== 1) return;
      try {
        await api.post("/estadocivils", this.datoEstadoCivil);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Estado civil actualizado exitosamente." });
        this.getData();
      } catch (error) {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
        const arr = Object.values(error.response?.data?.errors || {});
        arr.forEach(e => Swal.fire(String(e)));
      }
    },

    async deleteEstadoCivil(idEstadoCivil) {
      const confirm = await Swal.fire({
        title:             "¿Eliminar estado civil?",
        text:              "Esta acción no se puede deshacer.",
        icon:              "warning",
        showCancelButton:  true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText:  "Cancelar",
      });
      if (!confirm.isConfirmed) return;
      try {
        await api.delete("/estadocivils/" + idEstadoCivil);
        this.getData();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo eliminar." });
      }
    },

    // ── Modales ───────────────────────────────────────────────
    abrirModalCrear() {
      this.modalWindow     = true;
      this.datoEstadoCivil = {};
      this.titulo          = "Crear Estado Civil";
      this.btnCrear        = true;
      this.btnEditar       = false;
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },

    async abrirModalEditar(idEstadoCivil) {
      this.modalWindow = true;
      this.titulo      = "Editar Estado Civil";
      this.btnCrear    = false;
      this.btnEditar   = true;
      try {
        const resp           = await api.get("/vwestadocivils/" + idEstadoCivil);
        this.datoEstadoCivil = resp.data;
      } catch (e) {
        console.error("Error al cargar estado civil:", e);
        return;
      }
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },

    abrirEditar(idEstadoCivil) {
      if (idEstadoCivil != null) this.$router.push("/estadocivilmd/" + idEstadoCivil);
    },
  },
};
</script>